// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
/** this is not new usage - old code extracted from editor-core */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var buttonStyle = css({
  height: '26px',
  width: '26px',
  background: "var(--ds-background-neutral, #091E420F)",
  padding: 0,
  borderRadius: "var(--ds-radius-small, 4px)",
  border: "1px solid ".concat("var(--ds-border-inverse, #FFFFFF)"),
  cursor: 'pointer',
  display: 'block'
});
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */

/** this is not new usage - old code extracted from editor-core */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var buttonWrapperStyle = css({
  border: '1px solid transparent',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  fontSize: 0,
  display: 'flex',
  alignItems: 'center',
  padding: "var(--ds-space-025, 2px)",
  borderRadius: "var(--ds-radius-medium, 6px)",
  '&:focus-within, &:focus, &:hover': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    borderColor: "var(--ds-border, #091E4224)".concat(" !important")
  }
});
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */